import { Link } from 'react-router-dom';
import { siteStats } from '@/mocks/news';

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20theater%20stage%20with%20amber%20and%20crimson%20light%20beams%2C%20floating%20dust%20particles%2C%20deep%20shadowed%20background%2C%20artistic%20stylized%20cinematic%20composition%2C%20rich%20warm%20tones%2C%20moody%20atmosphere&width=1800&height=1100&seq=kldg-hero-main-01&orientation=landscape"
          alt="看料大瓜热点合集盘点首屏背景"
          title="看料大瓜 - 热点事件合集盘点"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/65 to-foreground-950/85"></div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col justify-center px-4 pb-20 pt-32 md:px-6 md:pb-28 md:pt-44">
        <div className="rise-in max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs text-background-100 backdrop-blur">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-400"></span>
            本周热度榜已更新 · 06 个话题待补课
          </span>

          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl lg:text-6xl">
            看料大瓜
            <span className="mt-2 block text-xl font-medium text-primary-300 md:text-2xl lg:text-3xl">
              一站式补瓜 · 热点事件合集盘点
            </span>
          </h1>

          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            不用东翻西找，这里按时间线整理好了近期最热门的瓜田事件与精华讨论。吃瓜老手与新粉都适用的高效补瓜指南，三分钟看懂来龙去脉。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              浏览话题合集
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
            <a
              href="#heat"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              查看本周热度榜
            </a>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-50/15 bg-background-50/10 backdrop-blur md:mt-20 md:grid-cols-4">
          {siteStats.map((stat) => (
            <div key={stat.label} className="bg-foreground-950/40 px-5 py-6">
              <p className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{stat.value}</p>
              <p className="mt-1.5 text-xs text-background-200">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}